import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { applicationService } from '../services/api';
import { isAuthenticated, isStudent, getUserData } from '../utils/auth';
import './Applications.css';

function Applications() {
  const navigate = useNavigate();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated() || !isStudent()) {
      navigate('/login');
      return;
    }

    const userData = getUserData();
    const studentId = userData?.studentId || userData?.StudentId;
    if (!studentId) {
      setLoading(false);
      return;
    }

    applicationService.getApplicationsByStudent(studentId)
      .then((data) => setApplications(data || []))
      .catch(() => setApplications([]))
      .finally(() => setLoading(false));
  }, [navigate]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  if (!isAuthenticated() || !isStudent()) {
    return null;
  }

  return (
    <div className="applications">
      <div className="page-header">
        <div className="container">
          <h1>My Applications</h1>
          <p>Track all your job applications in one place</p>
        </div>
      </div>

      <div className="container">
        <div className="applications-content">
          {loading ? (
            <div className="applications-loading">Loading...</div>
          ) : applications.length === 0 ? (
            <div className="applications-empty">
              <div className="empty-icon">📋</div>
              <h2>No Applications Yet</h2>
              <p>You haven't applied to any positions yet. Start exploring available opportunities!</p>
              <Link to="/placement-drives" className="browse-btn">
                Browse Placement Drives
              </Link>
            </div>
          ) : (
            <div className="applications-list">
              <h2>Your Applications</h2>
              {applications.some((a) => a.IsShortlisted) && (
                <p className="shortlisted-summary">
                  You have <strong>{applications.filter((a) => a.IsShortlisted).length}</strong> shortlisted application(s).
                </p>
              )}
              {applications.map((app) => (
                <div key={app.Id} className={`application-card ${app.IsShortlisted ? 'shortlisted' : ''}`}>
                  <div className="application-card-header">
                    <div className="application-title-row">
                      <h3>{app.Vacancy?.Title}</h3>
                      {app.IsShortlisted && (
                        <span className="shortlisted-badge">Shortlisted</span>
                      )}
                    </div>
                    <span className="application-date">Applied: {formatDate(app.Date)}</span>
                  </div>
                  <div className="application-card-body">
                    <div className="application-meta">
                      {app.Vacancy?.Company?.Name && (
                        <span className="meta-item"><strong>Company:</strong> {app.Vacancy.Company.Name}</span>
                      )}
                      {app.Resume && (
                        <span className="meta-item">
                          <strong>Resume:</strong> {app.Resume.split(/[/\\]/).pop()}
                          <button
                            type="button"
                            className="download-pdf-btn"
                            onClick={() => applicationService.downloadResume(app.Id, app.Resume?.split(/[/\\]/).pop() || 'resume.pdf')}
                          >
                            Download PDF
                          </button>
                        </span>
                      )}
                    </div>
                    {app.Description && (
                      <div className="application-detail-section">
                        <strong>Additional Description:</strong>
                        <p>{app.Description}</p>
                      </div>
                    )}
                    {app.Answer1 && (
                      <div className="application-detail-section">
                        <strong>Answer 1:</strong>
                        <p>{app.Answer1}</p>
                      </div>
                    )}
                    {app.Answer2 && (
                      <div className="application-detail-section">
                        <strong>Answer 2:</strong>
                        <p>{app.Answer2}</p>
                      </div>
                    )}
                    {app.Answer3 && (
                      <div className="application-detail-section">
                        <strong>Answer 3:</strong>
                        <p>{app.Answer3}</p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Applications;

